import { Alert } from "@zapier/design-system";
import { ToastBar, Toaster, toast } from "react-hot-toast";

export const ToastViewport = () => {
  return (
    <Toaster
      position="bottom-right"
      gutter={8}
      toastOptions={{ duration: 5000 }}
    >
      {(t) => (
        <ToastBar
          toast={t}
          style={{
            padding: 0,
            boxShadow: "none",
            background: "transparent",
          }}
        >
          {({ message }) => {
            return (
              <Alert
                title={message}
                variant="toast"
                status={
                  t.type === "success" || t.type === "error"
                    ? t.type
                    : undefined
                }
                onDismiss={() => toast.dismiss(t.id)}
              />
            );
          }}
        </ToastBar>
      )}
    </Toaster>
  );
};
